'use strict'

module.exports = require('./html')



//////////////////
// WEBPACK FOOTER
// ./~/refractor/~/hastscript/index.js
// module id = 1095
// module chunks = 27180705640166